import { render, staticRenderFns } from "./VipSort.vue?vue&type=template&id=21441d00&scoped=true&"
import script from "./VipSort.vue?vue&type=script&lang=js&"
export * from "./VipSort.vue?vue&type=script&lang=js&"
import style0 from "./VipSort.vue?vue&type=style&index=0&id=21441d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21441d00",
  null
  
)

export default component.exports